import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers/rootReducer';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';

const middleware = [thunk];

const persistConfig = {
  key: 'reducer',
  storage
};

const presistedReducer = persistReducer(persistConfig, rootReducer );

const store = createStore(
  presistedReducer,
  {},
  compose(
    applyMiddleware(...middleware),
    //window.REDUX_DEVTOOLS_EXTENSION && window.REDUX_DEVTOOLS_EXTENSION(),
  ),
);
const persistor = persistStore(store);
export {persistor}
export default store;